import { render } from "./px-sidebar-divisor.vue?vue&type=template&id=d15e7cea&scoped=true&ts=true"
import script from "./px-sidebar-divisor.vue?vue&type=script&lang=ts"
export * from "./px-sidebar-divisor.vue?vue&type=script&lang=ts"

import "./px-sidebar-divisor.vue?vue&type=style&index=0&id=d15e7cea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d15e7cea"]])

export default __exports__